<div class="card">
  <div class="card-header bg-light">
    <span>Histórico de versões</span>
  </div>
  <div class="card-body wrapper">
    <table mat-table [dataSource]="dataSource" class="w-100">
      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef>Versão</th>
        <td mat-cell *matCellDef="let v">{{ v.numero }}</td>
      </ng-container>
      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let v">{{ v.descricao }}</td>
      </ng-container>
      <ng-container matColumnDef="dataHora">
        <th mat-header-cell *matHeaderCellDef>Data e hora</th>
        <td mat-cell *matCellDef="let v">{{ v.dataHora | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>
      <ng-container matColumnDef="responsavel">
        <th mat-header-cell *matHeaderCellDef>Responsável</th>
        <td mat-cell *matCellDef="let v">{{ v.responsavelNome || v.responsavelId }}</td>
      </ng-container>
      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let v">
          <button type="button" class="btn btn-info btn-sm mr-1" (click)="imprimirPlano(v)" *ngIf="podeImprimir">
            <i class="far fas fa-print"></i> Plano de ação
          </button>
          <button type="button" class="btn btn-info btn-sm mr-1" (click)="imprimirRelatoria(v)" *ngIf="podeRelatoria">
            <i class="far fas fa-print"></i> Relatoria
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div *ngIf="!dataSource?.data?.length" class="text-center p-3">Nenhuma versão gerada.</div>
  </div>
  <div class="card-footer">
    <button type="button" class="btn btn-default btn-sm" (click)="onFechar()">
      <i class="fas fa-times"></i> Fechar
    </button>
  </div>
</div>
